import React from 'react'

const Languages = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Linguagens</h3>
      <div className="skills__box">

        <div className="skills__group">
          <div className="skills__data">
            <a href="https://developer.mozilla.org/pt-BR/docs/Web/JavaScript" target="_blank" rel="noreferrer" title="Javascript">
              <i class="devicon-javascript-plain bx-lg" />
            </a>
            <div>
              <a href="https://www.typescriptlang.org/" target="_blank" rel="noreferrer" title="Typescript">
                <i class="devicon-typescript-plain bx-lg" />
              </a>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <a href="https://www.java.com/pt-BR/" target="_blank" rel="noreferrer" title="Java">
              <i class="devicon-java-plain bx-lg" />
            </a>
            <div>
            <a href="https://www.php.net/" target="_blank" rel="noreferrer" title="Php">
              <i class="devicon-php-plain bx-lg" />
            </a>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <div>
              <a href="https://www.python.org/" target="_blank" rel="noreferrer" title="Mysql">
                <i class="devicon-python-plain bx-lg" />
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>


  );
}

export default Languages;